import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=7c552a55&"
import script from "./Opening.vue?vue&type=script&lang=js&"
export * from "./Opening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports